import * as z$1 from "zod/v4";
//#region src/schemas/protocol/shared.ts
const trimmedStringFromUnknown = (value) => String(value ?? "").trim();
const nonEmptyTrimmedStringFromUnknown = z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1));
const finiteIntegerNumber = z$1.number().int().finite();
const optionalBooleanQuerySchema = z$1.preprocess((value) => {
	if (value === void 0 || value === null || value === "") return;
	if (typeof value === "boolean") return value;
	const normalized = String(value).trim().toLowerCase();
	if (normalized === "true" || normalized === "1") return true;
	if (normalized === "false" || normalized === "0") return false;
	return value;
}, z$1.boolean().optional());
//#endregion
export { finiteIntegerNumber, nonEmptyTrimmedStringFromUnknown, optionalBooleanQuerySchema, trimmedStringFromUnknown };

//# sourceMappingURL=shared.js.map